import Login from "@/components/auth/Login";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [backgroundImage, setBackgroundImage] = useState<string>('/lovable-uploads/dbe92a5b-4c09-4cdc-a6d1-29e0f1355e0c.png');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  
  useEffect(() => {
    const fetchBackgroundImage = async () => {
      try {
        console.log('Fetching login background image...');
        const { data, error } = await supabase
          .from('site_settings')
          .select('value')
          .eq('key', 'login_background_image')
          .single();
        
        console.log('Database response:', { data, error });
        
        if (!error && data && data.value) {
          console.log('Setting background image to:', data.value);
          // Add cache-busting timestamp to force image refresh
          const imageUrl = data.value.includes('?') 
            ? `${data.value}&t=${Date.now()}` 
            : `${data.value}?t=${Date.now()}`;
          setBackgroundImage(imageUrl);
        } else {
          console.log('No background image found or error occurred, using default');
        }
      } catch (err) {
        console.error('Error fetching background image:', err);
      }
    };
    
    fetchBackgroundImage();

    // Set up real-time subscription for site_settings changes
    const channel = supabase
      .channel('site_settings_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'site_settings',
          filter: 'key=eq.login_background_image'
        },
        (payload) => {
          console.log('Real-time update received:', payload);
          if (payload.new && typeof payload.new === 'object' && 'value' in payload.new && payload.new.value) {
            const imageUrl = payload.new.value.includes('?') 
              ? `${payload.new.value}&t=${Date.now()}` 
              : `${payload.new.value}?t=${Date.now()}`;
            setBackgroundImage(imageUrl);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);
  useEffect(() => {
    const error = searchParams.get("error");
    if (error === 'registration_closed') {
      setErrorMessage("Vi har för närvarande begränsat åtkomsten till fritidskompassen.se. Detta för att upprätthålla maximal säkerhet för våra användare.");
    } else if (error === 'unauthorized_municipality') {
      setErrorMessage("Du har inte behörighet att logga in på den valda kommunen. Kontrollera att du valt rätt kommun eller kontakta en administratör.");
    } else if (error === 'municipality_not_assigned') {
      setErrorMessage("Din kommun har inte tilldelats ännu. Vänligen kontakta en administratör för att få din kommun korrekt tilldelad.");
    } else if (error === 'general') {
      setErrorMessage("Ett fel uppstod vid inloggning. Försök igen.");
    } else if (error === 'developer_login_failed') {
      setErrorMessage("Utvecklarinloggning misslyckades. Kontrollera ditt lösenord.");
    } else {
      setErrorMessage(null);
    }

    // Rensa URL:en från felparametern efter att meddelandet visats
    if (error) {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [searchParams]);
  return <div className="h-screen flex flex-col overflow-hidden relative">
      <div className="absolute inset-0 w-full h-full z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('${backgroundImage}')`
    }} />
      
      <div className="absolute inset-0 flex items-center justify-center z-20">
        <div className="w-full max-w-md mx-auto px-4">
          <div className="w-full bg-white/10 backdrop-blur-xl p-6 rounded-2xl shadow-2xl border border-white/20 ring-1 ring-white/10">
            <h1 className="font-stolzl text-3xl font-bold text-white mt-10 mb-4 text-center drop-shadow-lg">Välkommen till</h1>
            <img alt="Fritidskompassen Logo" className="w-48 md:w-64 mx-auto mb-4" src="/lovable-uploads/eb531015-7c97-44e7-b7e0-f6a6bba1957e.png" />
            {errorMessage && <Alert variant="destructive" className="mb-4">
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>{errorMessage}</AlertDescription>
              </Alert>}
            <div className="flex justify-center">
              <Login />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default LoginPage;